import _get from 'lodash/get';
import eventService from '../common/eventService';
import rules from '../constants/businessRules/businessRules';
import areBlocksEqual from '../common/areBlocksEqual';

let shouldTriggerAutoSave = false;
let isSaveFired = false;
let refreshPreviouslyTriggered = false;
let showExitWarning = true;

export const setIsSaveFired = (status) => {
    isSaveFired = status;
};

const triggerSaveIfNeeded = () => {
    if (shouldTriggerAutoSave) {
        setIsSaveFired(true);
        eventService.triggerAutoSave();
        shouldTriggerAutoSave = false;
        refreshPreviouslyTriggered = false;
    }
};

let autoSave = window.setInterval(() => triggerSaveIfNeeded(), rules.AUTO_SAVE_TIME_INTERVAL);

window.onunload = () => {
    window.clearInterval(autoSave);
};

window.self.addEventListener('beforeunload', (ev) => {
    // unload without exit warning message
    if (!showExitWarning) {
        return;
    }

    if (shouldTriggerAutoSave || isSaveFired) {
        ev.preventDefault();

        // for older browsers
        return (ev.returnValue = 'Are you sure you want to exit Email Designer? Any unsaved changes could be lost.');
    }
});

export const stopAutoSaveTrigger = () => {
    shouldTriggerAutoSave = false;
};

export const startAutoSaveTrigger = () => {
    shouldTriggerAutoSave = true;
};

export const resetAutoSaveTimer = () => {
    window.clearInterval(autoSave);
    autoSave = window.setInterval(() => triggerSaveIfNeeded(), rules.AUTO_SAVE_TIME_INTERVAL);
};

export const disableAutoSaveTimer = () => {
    window.clearInterval(autoSave);
};

export const enableExitWarning = () => {
    showExitWarning = true;
};

export const disableExitWarning = () => {
    showExitWarning = false;
};

const middleware = (store) => (next) => (action) => {
    // we do the action first so the store is updated
    // and then we can update the auto save variable.
    const actionResponse = next(action);
    const { getState } = store;
    const state = getState();
    // the parent window needs to handle the o exit message
    eventService.updateChangesExistStatus(shouldTriggerAutoSave || isSaveFired);

    // using items as that will match the save button active/inactive
    const latestVersionHistorySavedItem = _get(state, 'versionHistory.latestVersionHistorySavedItem', {});
    const latestSavedBlocks = _get(latestVersionHistorySavedItem, 'blocks', []);
    const blocks = _get(state, 'canvasBlocks.present', []);
    const changes = blocks.length !== 0 && !areBlocksEqual(blocks, latestSavedBlocks);

    // trigger save for text changes and undo/redo events
    if (!changes) {
        // if the user restores previous changes before a save.
        shouldTriggerAutoSave = false;
        refreshPreviouslyTriggered = false;
    } else if (action.type === 'columnItemTypes/REFRESH_COLUMN_ITEM_CONTENT' || refreshPreviouslyTriggered) {
        shouldTriggerAutoSave = true;
        refreshPreviouslyTriggered = true;
    } else if (changes) {
        shouldTriggerAutoSave = true;
    }

    return actionResponse;
};

export default middleware;
